import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '1375280757244902';
    // Initialize fbq function
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ?
        // @ts-ignore
        window.fbq.callMethod.apply(window.fbq, arguments) :
        // @ts-ignore
        window.fbq.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = window.fbq;
      // @ts-ignore
      window.fbq.push = window.fbq;
      // @ts-ignore
      window.fbq.loaded = true;
      // @ts-ignore
      window.fbq.version = '2.0';
      // @ts-ignore
      window.fbq.queue = [];
      // Load the pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize pixel and track PageView
      script.onload = () => {
        // @ts-ignore
        window.fbq('init', pixelId);
        // @ts-ignore
        window.fbq('track', 'PageView');
      };
      // Cleanup
      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    }
  }, []);
  // Noscript fallback
  return <noscript data-id="element-218">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1375280757244902&ev=PageView&noscript=1" alt="" data-id="element-219" />
    </noscript>;
}